var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-container"},[_c('div',{staticClass:"ad",style:({width: _vm.width,height: _vm.height}),on:{"click":_vm.clickAd}},[(_vm.content.image)?_c('img',{attrs:{"src":_vm.content.image}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }